import React, { FC } from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const AddUserForm = lazyLoader(
  () => import("Containers/User/AddUserForm/AddUserForm")
);

export const AddUser: FC = () => {
  return (
    <Layout>
      <AddUserForm />
    </Layout>
  );
};
